import { cva, type VariantProps } from 'class-variance-authority';

export const comparisonBarVariants = cva('pointer-events-none z-50 w-full', {
  variants: {
    position: {
      fixed: 'fixed inset-x-0 bottom-0',
      static: 'relative',
    },
  },
  defaultVariants: {
    position: 'fixed',
  },
});

export const comparisonBarPanelVariants = cva(
  'pointer-events-auto w-full items-start motion-reduce:animate-none',
  {
    variants: {
      animation: {
        slideUp: 'animate-slide-in-from-bottom',
        none: '',
      },
    },
    defaultVariants: {
      animation: 'slideUp',
    },
  },
);

export const comparisonBarViewportSpacerVariants = cva('h-56 md:h-48 lg:h-44');

export const comparisonBarSlotLayoutVariants = cva(
  [
    'relative min-w-0 flex-1 items-center justify-center',
    'aspect-logo-box max-h-logo-box max-w-logo-box w-auto',
    'md:h-logo-box md:w-logo-box md:flex-none',
  ],
  {
    variants: {
      state: {
        selected: 'p-xxs',
        empty: 'border-dashed',
      },
    },
    defaultVariants: {
      state: 'empty',
    },
  },
);

export const comparisonBarMobileHeaderVariants = cva(
  'grid grid-cols-[1fr_auto_1fr] items-center gap-sm md:hidden',
);

export const comparisonBarMobileHeaderStatusVariants = cva('col-start-2');

export const comparisonBarCollapseToggleVariants = cva('justify-self-end');

export const comparisonBarCollapsedContentVariants = cva('', {
  variants: {
    collapsed: {
      true: 'hidden md:flex',
      false: 'flex',
    },
  },
  defaultVariants: {
    collapsed: false,
  },
});

export const comparisonBarMetaStatusVariants = cva('shrink-0');

export const comparisonBarClearButtonVariants = cva('w-fit shrink-0', {
  variants: {
    placement: {
      meta: '',
      actions: 'lg:hidden',
    },
  },
  defaultVariants: {
    placement: 'meta',
  },
});

export const comparisonBarCompareButtonVariants = cva('shrink-0');

export const comparisonBarContentRowVariants = cva('lg:items-center lg:gap-lg');

export const comparisonBarSelectionClusterVariants = cva(
  'lg:flex-row lg:items-center lg:gap-lg',
);

export const comparisonBarTabletStatusVariants = cva(
  'hidden w-full md:block lg:hidden',
);

export const comparisonBarTabletBodyVariants = cva(
  'md:items-center md:justify-between lg:contents',
);

export const comparisonBarLogoSlotsRowVariants = cva(
  'min-w-0 shrink-0 items-stretch md:w-auto md:justify-start lg:gap-lg',
);

export const comparisonBarActionsGroupVariants = cva(
  'shrink-0 md:w-auto lg:ml-auto',
);

export const comparisonBarMetaRowVariants = cva('hidden lg:contents');

export const comparisonBarRemoveButtonLayoutVariants = cva(
  'absolute -right-xxs -top-xxs h-md w-md',
);

export type ComparisonBarClearButtonVariantProps = VariantProps<
  typeof comparisonBarClearButtonVariants
>;

export type ComparisonBarVariantProps = VariantProps<
  typeof comparisonBarVariants
>;
